<template>
  <div class="footer-bg">
    <div class="container">
      <div class="footer-columns">
        <div class="footer-column">
          <span style="cursor: pointer" @click="handleScroll('index')">{{
            $t("header.nav")
          }}</span>
        </div>
        <div class="footer-column">
          <span>{{ $t("header.nav2") }}</span>
          <div>
            <div class="footer-item" @click="handleScroll('acq')">
              {{ $t("header.nav2_1") }}
            </div>
            <div class="footer-item" @click="handleScroll('account')">
              {{ $t("header.nav2_2") }}
            </div>
            <div class="footer-item" @click="handleScroll('payment')">
              {{ $t("header.nav2_3") }}
            </div>
          </div>
        </div>
        <div class="footer-column">
          <span>{{ $t("header.nav3") }}</span>
          <div>
            <div class="footer-item" @click="handleScroll('system')">
              {{ $t("header.nav3_1") }}
            </div>
            <div class="footer-item" @click="handleScroll('tool')">
              {{ $t("header.nav3_2") }}
            </div>
          </div>
        </div>
        <div class="footer-column">
          <span>{{ $t("header.nav4") }}</span>
          <div>
            <div class="footer-item" @click="handleScroll('develop')">
              {{ $t("header.nav4_1") }}
            </div>
          </div>
        </div>
        <div class="footer-column">
          <span>{{ $t("header.nav5") }}</span>
          <div>
            <div class="footer-item" @click="handleScroll('about')">
              {{ $t("header.nav5_1") }}
            </div>
            <div class="footer-item" @click="handleScroll('contact-us')">
              {{ $t("header.nav5_2") }}
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-email">联系邮箱：support@nuwa-pay.com</div>
        <div class="footer-filing">
          {{ $t("footer.copyright") }}
          <a href="https://beian.miit.gov.cn/" target="_blank">{{
            $t("footer.icp")
          }}</a>
        </div>
        <div class="footer-copy">
          <span @click="toStatement">{{ $t("footer.statement") }}</span
          >| <span @click="toTermUse">{{ $t("footer.termuse") }}</span
          >|<span @click="toPrivacy">{{ $t("footer.privacy") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeId: "home"
    };
  },
  watch: {
    $route: {
      immediate: true, // 如果需要在组件创建时立即触发，设置为true
      handler(newVal, oldVal) {
        this.activeId = newVal.name;
      }
    }
  },
  methods: {
    handleScroll(domId) {
      if (this.activeId == domId) return;
      switch (domId) {
        case "index":
          this.$router.push("/");
          break;
        case "develop":
          const url =
            "https://documenter.getpostman.com/view/32291077/2sA3sAi7rD";
          window.open(url);
          break;
        default:
          this.$router.push(`/${domId}`);
          break;
      }
    },
    toPrivacy() {
      this.$router.push("/privacyPolicy");
      // const url = `https://dashboard.zantechglobal.com/#/privacyPolicy?lang=${
      //   this.$i18n.locale == "zh" ? "zh-CN" : "en-US"
      // }`;
      // window.open(url);
    },
    toTermUse() {
      this.$router.push("/termUse");
      // const url = `https://dashboard.zantechglobal.com/#/termUse?lang=${
      //   this.$i18n.locale == "zh" ? "zh-CN" : "en-US"
      // }`;
      // window.open(url);
    },
    toStatement() {
      this.$router.push("/statement");
      // const url = `https://dashboard.zantechglobal.com/#/statement?lang=${
      //   this.$i18n.locale == "zh" ? "zh-CN" : "en-US"
      // }`;
      // window.open(url);
    }
  }
};
</script>

<style lang="less" scoped>
.footer-bg {
  padding: 50px 0 5px;
  background: #010104;
  color: #fff;
  display: flex;
  align-items: center;
  .footer-columns {
    display: flex;
    .footer-column {
      width: 20%;
      span {
        display: inline-block;
        margin-bottom: 20px;
        font-weight: 900;
        font-size: 26px;
        color: #ffffff;
        line-height: 39px;
      }
      .footer-item {
        font-weight: 400;
        font-size: 18px;
        color: #9e9e9e;
        line-height: 43px;
        cursor: pointer;
      }
    }
  }
  .footer-bottom {
    margin-top: 24px;
    border-top: 1px solid hsla(0, 0%, 100%, 0.4);
    padding: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .footer-email {
      flex-shrink: 0;
      width: 100%;
      text-align: right;
      margin-bottom: 12px;
    }
    .footer-filing {
      text-align: center;
      a {
        color: #fff;
      }
    }
    .footer-copy {
      span {
        margin: 0 5px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue